import {
  langReducer,
  modalReducer,
  oilFilterReducer,
  sortReducer,
  workshopReducer,
  countryReducer,
  countriesReducer,
  replacementReducer,
  serviceIntervalsReducer,
  vehicleComponentVolumesReducer,
  langsReducer,
  selectedLocationReducer,
  whereToBuyEnabledReducer,
  enableWtbDistanceFilterReducer,
  isMilesReducer,
  distanceInMilesOrKMReducer,
  locationTypesListReducer,
  locationCategoriesListReducer,
  productCategoriesListReducer,
  whereToServiceEnabledReducer,
  hasCastrolCertifiedWorkshopsReducer,
  recommendedProductsReducer,
  resultsReducer,
  licenseKeysReducer,
  loadingReducer,
  isIrelandReducer
} from './reducer';
import { combineReducers, createStore } from 'redux';

const store = createStore(
  combineReducers({
    filter: oilFilterReducer,
    sort: sortReducer,
    workshops: workshopReducer,
    modal: modalReducer,
    lang: langReducer,
    country: countryReducer,
    countries: countriesReducer,
    replacements: replacementReducer,
    serviceIntervals: serviceIntervalsReducer,
    vehicleComponentVolumes: vehicleComponentVolumesReducer,
    langs: langsReducer,
    selectedLocation: selectedLocationReducer,
    whereToBuyEnabled: whereToBuyEnabledReducer,
    enableWtbDistanceFilter: enableWtbDistanceFilterReducer,
    isMiles: isMilesReducer,
    distanceInMilesOrKM: distanceInMilesOrKMReducer,
    locationTypesList: locationTypesListReducer,
    locationCategoriesList: locationCategoriesListReducer,
    productCategoriesList: productCategoriesListReducer,
    whereToServiceEnabled: whereToServiceEnabledReducer,
    hasCastrolCertifiedWorkshops: hasCastrolCertifiedWorkshopsReducer,
    recommendedProducts: recommendedProductsReducer,
    results: resultsReducer,
    licenseKeys: licenseKeysReducer,
    loading: loadingReducer,
    isIreland: isIrelandReducer,
  }),
);

export default store;
